/*
 * ScrollToTop
 *
 * runs the functionality of the scroll to top button that appears at the bottom right of the website
 * TCD-7: Replaced 250ms setInterval polling with rAF-based scroll tracking for instant response.
 * Scroll uses the native window.scrollTo API so it cooperates with the global
 * `html { scroll-behavior: smooth }` (src/styles/base/_base.scss) instead of fighting it.
 * jQuery's $.animate({ scrollTop }) conflicts with that CSS rule and stalls ~600ms before moving.
 */
/* eslint-disable */

function scrollToTop() {
	const selector = '.js-scroll-to-top';
	const activeClass = 'a-scroll-to-top--active';
	const activeDistance = 200;
	const scrollTo = 0;

	let ticking = false;

	function updateButton() {
		if ($(window).scrollTop() > activeDistance) {
			$(selector).addClass(activeClass);
		} else {
			$(selector).removeClass(activeClass);
		}
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			requestAnimationFrame(updateButton);
			ticking = true;
		}
	}

	$(window).on('scroll', onScroll);

	$(selector).on('click', function() {
		window.scrollTo({ top: scrollTo, behavior: 'smooth' });
		return false;
	});
}

export default scrollToTop;
